import { BENCHMARKS_COLORS } from 'common/utils/utils';
import _ from 'lodash';
import { CYCLE_TIME_METRICS_TITLES } from '../../../dashboard.service';

// will return a string of the cycle time item that needs to have the git stream cta badge and tooltip
export const getWhichMetricShouldShowGitStreamCTA = configurations => {
  const pickupColor = _.get(
    configurations.find(
      config => config.title === CYCLE_TIME_METRICS_TITLES.PICKUP
    ),
    'color'
  );
  const reviewColor = _.get(
    configurations.find(
      config => config.title === CYCLE_TIME_METRICS_TITLES.REVIEW
    ),
    'color'
  );

  if (reviewColor === BENCHMARKS_COLORS.POOR) {
    return CYCLE_TIME_METRICS_TITLES.REVIEW;
  }

  if (pickupColor === BENCHMARKS_COLORS.POOR) {
    return CYCLE_TIME_METRICS_TITLES.PICKUP;
  }

  if (reviewColor === BENCHMARKS_COLORS.FAIR) {
    return CYCLE_TIME_METRICS_TITLES.REVIEW;
  }

  if (pickupColor === BENCHMARKS_COLORS.FAIR) {
    return CYCLE_TIME_METRICS_TITLES.PICKUP;
  }

  return null;
};
